export const MeasuringModeName = Object.freeze(
    {
        SCAN: "SCAN",
        SIM: "SIM",
        SRM: "SRM",
        PRODUCT_SCAN: "PRODUCT_SCAN",
        PRECURSOR_SCAN: "PRECURSOR_SCAN"
    });